(async () => {

    const baseComponent = await import(window.theme.modules.baseComponent);

    customElements.define('main-nav', class extends baseComponent.default {
        elements = {
            dropdowns: '*[data-dropdown]'
        };

        modalInit = false;

        render() {
            this.$dropdowns.filter(drop => drop.hasAttribute('data-offset-drop')).map(dropdown => {
                const clientRect = dropdown.getBoundingClientRect();
                if (document.documentElement.clientWidth - clientRect.x + clientRect.width < 600) {
                    dropdown.classList.add('@drop-reverse');
                }
            })
        }

        reRender() {
            if(this.closest('modal-popup') && !this.modalInit) {
                this.modalInit = true;
                this.$dropdowns.map(dropdown => {
                    dropdown.addEventListener('click', (e) => {
                      //  e.preventDefault();
                        const dropId = e.currentTarget.dataset.dropdown;
                        const dropTarget = this.querySelector(`[data-dropby="${dropId}"]`);
                        dropTarget.classList.toggle('!active');
                    })
                })
            }
        }
    })
})();



document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('[class*="#main-nav-link"]').forEach(link => {
    const icon = link.querySelector('[class*="#icon"]');

    if (icon) {
      icon.addEventListener('click', function (e) {
        e.preventDefault();
        e.stopPropagation();

        const dropdownId = link.getAttribute('data-dropdown');
        const dropdown = document.querySelector(`[class*="#main-nav-dropdown"][data-dropby="${dropdownId}"]`);

        if (dropdown) {
          dropdown.classList.toggle('open'); // Add your own logic or class for showing dropdown
        }
      });
    }
  });
});




